/* @flow */

import {createAction} from 'redux-act';

import type {
    EngagementLeadsReportDataRequestedAction,
    EngagementLeadsListRequestedAction,
} from './types';

/*
 * Action creators
 */
export const requestReportData: (
    payload: $PropertyType<EngagementLeadsReportDataRequestedAction, 'payload'>
) => EngagementLeadsReportDataRequestedAction = createAction(
    'ENGAGEMENT_LEADS_REPORT_DATA_REQUESTED'
);
export const requestListData: (
    payload: $PropertyType<EngagementLeadsListRequestedAction, 'payload'>
) => EngagementLeadsListRequestedAction = createAction('ENGAGEMENT_LEADS_LIST_DATA_REQUESTED');
export const updateReportChartData = createAction('ENGAGEMENT_LEADS_REPORT_CHART_DATA_UPDATED');
export const updateReportMaps = createAction('ENGAGEMENT_LEADS_REPORT_MAPS_UPDATED');
export const failReportChartData = createAction('ENGAGEMENT_LEADS_REPORT_CHART_DATA_FAILED');

// List actions
export const updateListData = createAction('ENGAGEMENT_LEADS_LIST_DATA_UPDATED');
export const updateListSummaryData = createAction('ENGAGEMENT_LEADS_LIST_SUMMARY_DATA_UPDATED');
export const failListData = createAction('ENGAGEMENT_LEADS_LIST_DATA_FAILED');
